import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment'
import { HttpClient } from "@angular/common/http";
import { take } from 'rxjs/operators';
import { PublishedEventListsData, SortedEventListPublishInstances, getUpcomingAndPastEventListInstances } from 'globals/store/share.event-lists.data';
import { EventListComponent } from 'src/app/components/events/event-list.component';

@Component({
    selector: 'share-event-lists',
    template: `
<event-list
  *ngIf="!loading && !!data"
  [fullData]="data"
  [brandingData]="data.brandingData"
  [eventLists]="eventLists"
  [listInfo]="data.info"
  [loading]="false"
  [fromShare]="true"
></event-list>
    `,
    standalone: true,
    imports: [EventListComponent]
})
export class ShareEventListsComponent {
  readonly api = `${environment.functionsURL}api/v1`; // NOTE this is pointing to api/v1 not api/app
  publishCode: string
  loading = true
  data: PublishedEventListsData
  eventLists: SortedEventListPublishInstances
  UNAVAILABLE = 'Event list unavailable'

  constructor(private route: ActivatedRoute, private http: HttpClient) {
    this.route.params.subscribe(params => {
      if (!params || !params.hasOwnProperty('publishCode')) {
        this.loading = false
        document.title = this.UNAVAILABLE
      } else {
        this.publishCode = params.publishCode;
        document.title = "loading";
        this.downloadEventLists(this.publishCode)
      }
    })
  }

  downloadEventLists(publishCode: string) {
    console.log(`Should be downloading ${publishCode}`)
    this.http.post(`${this.api}/get-event-list-v1`, { id: publishCode }).pipe(take(1)).subscribe((data: PublishedEventListsData) => {
      console.log(data)
      this.data = data
      if (data) {
        this.eventLists = getUpcomingAndPastEventListInstances(this.data.instances)
        document.title = "Event list"
      } else document.title = this.UNAVAILABLE
      this.loading = false
    }, (error) => {
      console.log(error)
      this.loading = false;
      document.title = this.UNAVAILABLE
    })
  }

}

